import { make } from 'vuex-pathify'
import TaskRecord from '@/api/task_record'

const state = {
  taskRecord: {}
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state)
}

const actions = {
  async create({ commit, dispatch }, payload) {
    try {
      const response = await TaskRecord.create(payload)
      commit('SET_TASK_RECORD', response.data.record)
      commit('task/PUSH_TASK_RECORD', response.data.record, { root: true })
      const { message } = response
      dispatch('notify/show', message, { root: true })
      return response
    } catch (e) {
      return false
    }
  },

  async delete({ commit, dispatch }, id) {
    try {
      const response = await TaskRecord.delete(id)
      commit('task/UPDATE_TASK_RECORD', id, { root: true })
      dispatch('notify/show', response.message, { root: true })
      return response
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
